export const EmployeeManAlt = ({ ...props }: React.SVGProps<SVGSVGElement>) => (
   <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
   >
      <g clipPath="url(#clip0_1813_3799)">
         <path
            d="M14 14C17.8605 14 21 10.8605 21 7C21 3.1395 17.8605 0 14 0C10.1395 0 7 3.1395 7 7C7 10.8605 10.1395 14 14 14ZM14 1.16667C17.2165 1.16667 19.8333 3.7835 19.8333 7C19.8333 10.2165 17.2165 12.8333 14 12.8333C10.7835 12.8333 8.16667 10.2165 8.16667 7C8.16667 3.7835 10.7835 1.16667 14 1.16667ZM24.5 26.8333V27.4167C24.5 27.7387 24.2387 28 23.9167 28C23.5947 28 23.3333 27.7387 23.3333 27.4167V26.8333C23.3333 22.7057 20.6395 19.1952 16.9178 17.9678L15.2122 20.5263L16.8992 27.2767C16.9762 27.5893 16.7627 28.0012 16.3333 28.0012C16.0708 28.0012 15.8328 27.825 15.7675 27.559L14.0175 20.559C13.9778 20.3992 14.007 20.2312 14.098 20.0947L15.7208 17.661C15.1632 17.5572 14.588 17.5012 14 17.5012C13.412 17.5012 12.838 17.556 12.2803 17.661L13.902 20.0947C13.993 20.2312 14.0222 20.4003 13.9825 20.559L12.2325 27.559C12.166 27.825 11.9292 28.0012 11.6678 28.0012C11.2735 28.0012 11.0227 27.5882 11.102 27.2767L12.789 20.5263L11.0833 17.9678C7.36167 19.1952 4.66667 22.7057 4.66667 26.8333V27.4167C4.66667 27.7387 4.40533 28 4.08333 28C3.76133 28 3.5 27.7387 3.5 27.4167V26.8333C3.5 21.0443 8.211 16.3333 14 16.3333C19.789 16.3333 24.5 21.0443 24.5 26.8333Z"
            fill="white"
         />
      </g>
      <defs>
         <clipPath id="clip0_1813_3799">
            <rect width="28" height="28" fill="white" />
         </clipPath>
      </defs>
   </svg>
)
